module.exports = __webpack_public_path__ + "static/event_img1M@2x-70e7b599ebc04b9be5416e63a83cac37.png";